import React, { useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CaretRightOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import {
  Steps,
  Table,
  Collapse,
  Button,
  List,
  Modal,
  Space,
  Rate,
  notification,
} from "antd";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { orderDetailsSaga } from "./saga";
import * as selectors from "./selectors";
import {
  addressToStringMultiLine,
  dateToString,
} from "../../../../utils/formatter";
import RaiseDisputeForm from "../../../../forms/RaiseDisputeForm";
import FeedbackForm from "../../../../forms/FeedbackForm";
import ContactSupportForm from "../../../../forms/ContactSupportForm";
import AddGRNForm from "../../../../forms/AddGRNForm";
import PageHeader from "../../../../components/PageHeader";
import InputBox from "../../../../components/InputBox";
import UploadBox from "../../../../components/UploadBox";
import { useAuth } from "../../../../contexts/auth";
import * as roles from "../../../../constants/roles";
import ViewGRNForm from "../../../../forms/ViewGRNForm";
import EditGRNForm from "../../../../forms/EditGRNForm";
import "./style.css";

const { Panel } = Collapse;
const { Step } = Steps;

/*const styles = {
  progressContainer: {
    padding: "30px 0",
    //border: "2px solid #eff3f7",
    //borderRadius: 8,
    marginBottom: 30,
    overflowX: "scroll",
  },
  addressSection: {
    flex: 2,
    padding: "30px",
    backgroundColor: "#eff3f7",
    borderRadius: 8,
    display: "flex",
    justifyContent: "space-between",
  },
  reportSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    padding: "20px",
    backgroundColor: "#eff3f7",
    marginLeft: 20,
    borderRadius: 8,
  },
};
*/
const columns = [
  {
    title: "Description",
    dataIndex: "description",
  },
  { title: "Price", dataIndex: "price" },
];

const PackageBlock = ({ data }) => {
  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;
  const [showDetails, setShowDetails] = useState(false);
  const { sampleCount } = data;
  const { tests } = data;
  const testCategories = {};

  tests.forEach((testObj) => {
    const categoryName = testObj?.testCategory?.name;
    if (!testCategories[testObj?.testCategory?.testCategory_id]) {
      testCategories[testObj.testCategory.testCategory_id] = {
        name: categoryName,
        parameters: [{ name: testObj.parameter, id: testObj._id }],
      };
    } else {
      testCategories[testObj.testCategory.testCategory_id].parameters.push({
        name: testObj.parameter,
        id: testObj._id,
      });
    }
  });

  const commodity = tests[0].commodity;

  const renderTestCategories = (categories) => {
    const rows = [];
    Object.keys(categories).forEach((key, index) => {
      const entry = categories[key];
      const parameters = entry.parameters || [];
      if (parameters.length) {
        rows.push(
          <Panel
            header={
              <span style={{ fontWeight: "bold", color: "#0a8080" }}>
                {`${entry.name} (${parameters.length} tests)`}
              </span>
            }
            key={index}
            style={{
              marginBottom: 20,
              overflow: "hidden",
              backgroundColor: "#eff3f7",
              border: "0px",
              borderRadius: 4,
              color: "#0a8080",
            }}
            id="panelOrderDetailsHeader"
          >
            <List
              itemLayout="horizontal"
              dataSource={parameters}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <span className="orderDetailsTestTitle">{item.name}</span>
                    }
                  />
                  {/* currentUser.role === roles.COMPANY_ADMIN.name ||
                  priceVisible ? (
                    <div className="orderDetailsTestTitle"> ₹ {item.price}</div>
                  ) : (
                    ""
                  ) */}
                </List.Item>
              )}
            />
          </Panel>
        );
      }
    });
    return rows;
  };

  return (
    <div className="packageSection">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>
          <strong>Package:</strong> {data.name}
        </p>

        <div style={{ width: 120 }}>
          {/*currentUser.role === roles.COMPANY_ADMIN.name || priceVisible ? (
            <p>Price: ₹ {data.cost * sampleCount}</p>
          ) : (
            ""
          )*/}
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ flex: 1, paddingRight: 40 }}>
          <p>
            <strong>Commodity:</strong> {commodity.name}
          </p>
          {showDetails ? (
            <div>
              <Collapse
                bordered={false}
                expandIconPosition="right"
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    style={{ color: "#0a8080" }}
                    rotate={isActive ? 90 : 0}
                  />
                )}
                style={{ background: "#fff" }}
              >
                {renderTestCategories(testCategories)}
              </Collapse>
              {/*<p>Notes: {data.notes}</p>
              <p>Sample Count: {sampleCount}</p>*/}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="packageWidth">
          {showDetails ? (
            <p
              onClick={() => setShowDetails(false)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Hide Details
            </p>
          ) : (
            <p
              onClick={() => setShowDetails(true)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              More Details
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

const OrderDetailsPage = () => {
  const { id } = useParams();
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: orderDetailsSaga });
  const dispatch = useDispatch();
  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;

  const [supportTabModalVisible, setSupportTabModalVisible] = useState(false);
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);
  const [feedbackModalFormVisible, setFeedbackModalFormVisible] =
    useState(false);
  const [disputeModalVisible, setDisputeModalVisible] = useState(false);
  const [poModalVisible, setPoModalVisible] = useState(false);
  const [viewGRNModalVisible, setViewGRNModalVisible] = useState(false);
  const [addGRNModalVisible, setAddGRNModalVisible] = useState(false);
  const [editGRNModal, setEditGRNModal] = useState(false);
  const [windowSize, setWindowSize] = useState(null);
  const [rejectionModalVisible, setRejectionModalVisible] = useState(false);
  let dataForKeyParameterValues = [];

  useEffect(() => {
    dispatch(actions.fetchOrderDetailsReset());
    dispatch(actions.fetchOrderDetails(id));
    dispatch(actions.fetchCompanyFeatures());
  }, [dispatch, id]);

  const orderDetails = useSelector(selectors.selectOrderDetails) || {};
  const checkForGRN = useSelector(selectors.selectCheckForGRN);
  const orderStatus = orderDetails?.status;
  const { grn, grnFile, orderId } = orderDetails;

  useEffect(() => {
    dispatch(actions.fetchCompanyFeatures({ companyId: company._id }));
  }, [dispatch, orderId, company]);

  const requestingHardcopy = useSelector(selectors.selectRequestingHardcopy);
  const raisingDispute = useSelector(selectors.selectRaisingDispute);
  const selectContactSupport = useSelector(selectors.selectContactSupport);

  const tableData = [];
  const { packages = [], feedback = null } = orderDetails;
  packages.forEach((pack) => {
    tableData.push({
      description: `Package: ${pack.name}`,
      price: `₹ ${pack.cost * pack.sampleCount}`,
    });
  });
  tableData.push({
    description: "Total Package Cost",
    price: `₹ ${orderDetails.total}`,
  });
  tableData.push({
    description: "Discount",
    price: `(-) ${orderDetails.discount}`,
  });
  tableData.push({
    description: "Total Cost",
    price: `₹ ${orderDetails.grandTotal}`,
  });

  dataForKeyParameterValues = packages[0]?.package?.keyParameters?.map(
    (obj) => {
      let requiredObj = { parameter: obj.parameter };
      if (orderDetails.labResponseId) {
        let valueObj = orderDetails?.labResponseId?.keyParametersValues?.find(
          (el) => el.parameter === obj.parameter
        );
        requiredObj.parameterValue = valueObj?.parameterValue;
      } else {
        requiredObj.parameterValue = "";
      }
      return requiredObj;
    }
  );

  const handlePurchaseOrderDownload = () => {
    dispatch(
      actions.downloadFile({
        id,
        data: { fileName: orderDetails.purchaseOrderFile },
      })
    );
  };

  const handleGRNFileDownload = () => {
    dispatch(
      actions.downloadFile({
        id,
        data: { fileName: grnFile },
      })
    );
  };

  const handleReportHardcopy = () => {
    dispatch(
      actions.requestReportHardCopy({
        id,
      })
    );
  };

  const handleReportDownload = () => {
    dispatch(
      actions.downloadFile({
        id,
        data: { fileName: orderDetails.labResponseId.reportFile },
      })
    );
  };

  const handleDownloadMetadata = () => {
    dispatch(
      actions.downloadFile({
        id,
        data: { fileName: orderDetails.labResponseId.reportMetadataFile },
      })
    );
  };

  const handleRaiseDispute = (data) => {
    dispatch(
      actions.raiseDispute({
        id,
        payloadData: data,
      })
    );
  };

  const handleContactSupport = (data) => {
    data.data.email = orderDetails.user.email;
    data.data.orderId = orderDetails._id;
    dispatch(
      actions.contactSupport({
        payloadData: data,
      })
    );
  };

  const handleFeedback = (payload) => {
    payload.orderId = orderDetails._id;
    dispatch(actions.feedback(payload));
  };

  const handleAddGRN = (payload) => {
    payload.data.id = orderDetails._id;
    payload.data.orderId = orderDetails.orderId;
    payload.data.source = "Order Details";
    payload.data.fileUsedFor = "GRN";
    payload.data.company = orderDetails.user.company._id;
    dispatch(actions.addGRN(payload));
  };

  const handleUpdateGRN = (payload) => {
    payload.data.id = orderDetails._id;
    payload.data.orderId = orderDetails.orderId;
    payload.data.source = "Order Details";
    payload.data.fileUsedFor = "GRN";
    payload.data.company = orderDetails.user.company._id;
    dispatch(actions.updateGRNDetails(payload));
  };

  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState("");
  const [purchaseOrderFile, setPurchaseOrderFile] = useState("");
  const [purchaseOrderFileError, setPurchaseOrderFileError] = useState(null);

  const handleFileUpload = (e) => {
    if (e?.target?.files[0]?.type !== "application/pdf") {
      setPurchaseOrderFileError(true);
      setPurchaseOrderFile(null);
      return;
    }
    setPurchaseOrderFileError(null);
    setPurchaseOrderFile(null);
    const files = e.target.files;
    if (files.length) {
      const fileToUpload = files[0];
      setPurchaseOrderFile(fileToUpload);
    }
  };

  const handleSuccess = () => {
    setPurchaseOrderNumber(null);
    setPurchaseOrderFile(null);
    setPoModalVisible(false);
    notification.success({
      message: "PO Updated Successfully!!",
    });
  };

  const handleFailure = () => [
    notification.error({
      message: "Error Updating PO!",
      description: `An error occured while updating Purchase Order. Please try again!`,
    }),
  ];

  const handleUpdatePo = () => {
    const payload = {
      id: orderDetails._id,
      purchaseOrderFile,
      purchaseOrderNumber,
      source: "Purchase Order",
      companyId: orderDetails?.user?.company?._id,
      onSuccess: handleSuccess,
      onFailure: handleFailure,
    };

    dispatch(actions.updatePurchaseOrder(payload));
  };

  // const getSteps = (trail) => {
  //   const stepsToRetun = [];
  //   // remove pending
  //   trail.forEach(entry => {
  //     if (entry.status.value === 'pending') {

  //     }
  //   })

  //   return stepsToRetun
  // }

  // const steps = getSteps(orderDetails?.statusTrail);

  // Logic for Status Bar might need a change in future
  const getProgressStatus = () => {
    const { statusTrail } = orderDetails;

    /*  const timelineWithDispute = [
      "Pending",
      "Booked",
      "Out For Pickup",
      "Received at Lab",
      "Under Testing",
      "Report Uploaded",
      "Under Dispute",
      "Dispute Resolved",
      "Complete",
    ]; */
    const timelineWithoutDispute = [
      "Pending",
      "Booked",
      "Out For Pickup",
      "Received at Lab",
      "Under Testing",
      "Report Uploaded",
      "Complete",
    ];
    const timelineForRejectedByLab = [
      "Pending",
      "Booked",
      "Out For Pickup",
      "Rejected By Lab",
    ];
    let regretted = false;
    let underDispute = false;
    let currentProgress = statusTrail?.length - 1 || 0;
    let timeline = timelineWithoutDispute;

    statusTrail?.forEach((obj) => {
      if (obj.status?.value === "underDispute") {
        underDispute = true;
      }
      if (obj.status?.value === "paymentVerified") {
        currentProgress = currentProgress - 1;
      }
      if (obj.status?.value === "regret") {
        regretted = true;
      }
    });
    if (orderDetails?.status?.value === "rejectedByLab") {
      currentProgress = timelineForRejectedByLab.length - 1;
      timeline = timelineForRejectedByLab;
    }
    if (regretted) {
      timeline = statusTrail.map((obj) => obj.status.label);
      currentProgress = statusTrail?.length - 1;
    }
    if (underDispute) {
      timeline = statusTrail.map((obj) => obj.status.label);
      let statusTrailReduced = statusTrail.map((el) => el.status.value);
      if (statusTrailReduced.indexOf("completed") === -1)
        timeline.push("Completed");
      currentProgress = statusTrail?.length - 1;
    }

    return { timeline, currentProgress };
  };
  const { currentProgress, timeline } = getProgressStatus();

  useLayoutEffect(() => {
    function updateWindowSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener("resize", updateWindowSize);
    updateWindowSize();
    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);
  return (
    <div>
      <div>
        <PageHeader
          title={`Order#: ${orderDetails.orderId}`}
          actions={
            <Space>
              <div className="orderDetailsHeader">
                {orderDetails.labResponseId?.reportMetadataFile && (
                  <Button
                    size={
                      windowSize > 600
                        ? "large"
                        : windowSize > 500
                        ? "middle"
                        : "small"
                    }
                    onClick={() => {
                      /*
                      if (feedback === null) setFeedbackModalFormVisible(true);
                      else setFeedbackModalVisible(true);
                    */
                      handleDownloadMetadata();
                    }}
                    className="orderDetailsFeedbackButton"
                  >
                    Download Metadata
                  </Button>
                )}

                {/* orderDetails?.status?.value === "rejectedByLab" && (
                  <Button
                    size={
                      windowSize > 600
                        ? "large"
                        : windowSize > 500
                        ? "middle"
                        : "small"
                    }
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      setRejectionModalVisible(true);
                    }}
                  >
                    View Reasons For Rejection
                  </Button>
                ) */}
                {orderDetails.labResponseId?.reportFile && (
                  <Button
                    size={
                      windowSize > 600
                        ? "large"
                        : windowSize > 500
                        ? "middle"
                        : "small"
                    }
                    type="primary"
                    onClick={() => {
                      //setSupportTabModalVisible(true);
                      handleReportDownload();
                    }}
                  >
                    Download Report
                  </Button>
                )}
              </div>
            </Space>
          }
        />
        <div>
          <div className="progressContainer">
            <Steps
              progressDot
              responsive="true"
              current={currentProgress}
              size="small"
            >
              {timeline.map((title) => (
                <Step title={title} />
              ))}
            </Steps>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="leftSection">
              <div className="addressSection">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    overflow: "auto",
                  }}
                >
                  <div className="addressCol">
                    <p
                      style={{
                        fontWeight: "bold",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                    >
                      Sample Details
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Commodity:</span>{" "}
                      {orderDetails.commodity}
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Type:</span>{" "}
                      {orderDetails.sampleType}
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Sector:</span>{" "}
                      {orderDetails.sector}
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>State:</span> {""}
                      {orderDetails.state}
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>District:</span> {""}
                      {orderDetails.district}
                    </p>
                    {/*addressToStringMultiLine(orderDetails.billingAddress)*/}
                    {/* orderDetails.assignedLogistics && (
                    <>
                      <p style={{ fontWeight: "bold" }}>Assigned Logistics</p>
                      <p>{orderDetails.assignedLogistics?.name}</p>
                    </>
                  ) */}
                  </div>
                  {/*                   <div className="addressCol">
                    <p
                      style={{
                        fontWeight: "bold",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                    >
                      Sampler Details
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Name:</span> ABC
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Contact:</span> ABC
                    </p>
                    <p style={{ marginBottom: "0.4em" }}>
                      <span style={{ fontWeight: "bold" }}>Address:</span>{" "}
                      C-184, Industrial Area, Sector 75, Sahibzada Ajit Singh
                      Nagar, Punjab 140308
                    </p>
                  </div> */}
                  <div style={{ flex: 1 }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                    >
                      Pickup Address
                    </p>
                    <p>{orderDetails.samplerAddress}</p>
                    {/*<p
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Pickup Request Date
                  </p>
                  <p>{dateToString(orderDetails.pickupRequestDate)}</p>*/}
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    overflow: "auto",
                  }}
                >
                  <div className="addressCol">
                    <p
                      style={{
                        fontWeight: "bold",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                    >
                      Pickup Request Date
                    </p>
                    <p>{orderDetails.outForPickupDate}</p>

                    {/*addressToStringMultiLine(orderDetails.billingAddress)*/}
                    {/* orderDetails.assignedLogistics && (
                    <>
                      <p style={{ fontWeight: "bold" }}>Assigned Logistics</p>
                      <p>{orderDetails.assignedLogistics?.name}</p>
                    </>
                  ) */}
                  </div>
                </div>
              </div>

              {/*  <div className="reportSection">
              <Button
                disabled={
                  !orderDetails.reportFile || orderDetails.reportFile === ""
                }
                onClick={handleReportDownload}
                type="primary"
                className="reportSectionButton"
              >
                {orderDetails.reportFile
                  ? "View Report"
                  : "Report Not Available"}
              </Button>
              {orderDetails.purchaseOrderFile ? (
                <Button
                  type="primary"
                  onClick={handlePurchaseOrderDownload}
                  className="reportSectionButton"
                >
                  Download Purchase Order
                </Button>
              ) : (
                <Button
                  type="primary"
                  size={windowSize > 430 ? "middle" : "small"}
                  onClick={() => setPoModalVisible(true)}
                  className="reportSectionButton"
                >
                  Upload Purchase Order
                </Button>
              )}
              <Button
                onClick={() => setDisputeModalVisible(true)}
                type="dashed"
                disabled={
                  raisingDispute ||
                  !orderDetails.reportFile ||
                  orderDetails.status.value === "underDispute" ||
                  orderDetails.status.value === "completed" ||
                  orderDetails.status.value === "regret"
                }
                loading={raisingDispute}
                className="reportSectionButton"
              >
                Raise Dispute
              </Button>
              <Button
                onClick={handleReportHardcopy}
                loading={requestingHardcopy}
                disabled={
                  requestingHardcopy ||
                  !orderDetails.reportFile ||
                  orderDetails.reportHardCopyRequested
                }
                type="dashed"
                className="reportSectionButton"
              >
                {orderDetails.reportHardCopyRequested
                  ? "Report Hardcopy requested"
                  : "Request Hardcopy of Report"}
              </Button>
              {checkForGRN &&
                orderStatus &&
                orderStatus.label === "Completed" &&
                "grn" in orderDetails && (
                  <Button
                    onClick={() => setViewGRNModalVisible(true)}
                    type="primary"
                  >
                    View GRN
                  </Button>
                )}
              {checkForGRN &&
                orderStatus &&
                orderStatus.label === "Completed" &&
                !("grn" in orderDetails) && (
                  <Button
                    onClick={() => setAddGRNModalVisible(true)}
                    type="primary"
                  >
                    Add GRN
                  </Button>
                )}
            </div> */}
              <div className="orderInclusions">
                <p style={{ fontWeight: "bold" }}>Order Inclusions</p>
                {packages.length > 0 &&
                  packages.map((packageDetails) => (
                    <PackageBlock
                      key={packageDetails._id}
                      data={packageDetails}
                    />
                  ))}
              </div>
            </div>
            <div className="rightSection">
              <div className="orderSummary">
                <p style={{ fontWeight: "bold" }}>
                  {" "}
                  <span style={{ fontStyle: "italic" }}>
                    **(Only for Information Purposes)**
                  </span>
                </p>
                {/*                   <Table
                    columns={columns}
                    dataSource={tableData}
                    bordered
                    pagination={{
                      position: ["none", "none"],
                      disabled: tableData.length === 0 ? true : false,
                    }}
                  /> */}
                <div className="keyParametersSection">
                  {packages.length && dataForKeyParameterValues.length > 0 ? (
                    dataForKeyParameterValues.map((el, index) => (
                      <div
                        key={el.index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "8px",
                        }}
                      >
                        <span>
                          <strong>{el.parameter}</strong>
                        </span>
                        <span>{el.parameterValue}</span>
                      </div>
                    ))
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RaiseDisputeForm
        visible={disputeModalVisible}
        setVisible={setDisputeModalVisible}
        onSave={handleRaiseDispute}
        loading={raisingDispute}
      />
      <ContactSupportForm
        visible={supportTabModalVisible}
        setVisible={setSupportTabModalVisible}
        onSave={handleContactSupport}
        loading={selectContactSupport}
      />
      <ViewGRNForm
        visible={viewGRNModalVisible}
        setVisible={setViewGRNModalVisible}
        grn={grn}
        grnFile={grnFile}
        orderId={orderId}
        handleGRNFileDownload={handleGRNFileDownload}
        setEditGRNModal={setEditGRNModal}
      />
      <AddGRNForm
        visible={addGRNModalVisible}
        setVisible={setAddGRNModalVisible}
        onSave={handleAddGRN}
      />
      <EditGRNForm
        visible={editGRNModal}
        setVisible={setEditGRNModal}
        grn={grn}
        grnFile={grnFile}
        orderId={orderId}
        uploaded={true}
        onSave={handleUpdateGRN}
      />
      <FeedbackForm
        visible={feedbackModalFormVisible}
        setVisible={setFeedbackModalFormVisible}
        onSave={handleFeedback}
      />
      <Modal
        title="Your Feedback"
        visible={feedbackModalVisible}
        footer={null}
        onCancel={() => {
          setFeedbackModalVisible(false);
        }}
      >
        <div>
          <p>
            <strong>Your Ratings:</strong>
            <Rate
              defaultValue={feedback?.ratings}
              disabled
              style={{ fontSize: "20px" }}
            />
          </p>
          <div style={{ display: "flex" }}>
            <p>
              <strong>Comments:</strong>
            </p>
            <p style={{ marginLeft: "10px" }}>{feedback?.comments}</p>
          </div>
        </div>
      </Modal>
      <Modal
        title="Basic Modal"
        visible={poModalVisible}
        onOk={handleUpdatePo}
        okText="Update"
        onCancel={() => setPoModalVisible(false)}
      >
        <div>
          <InputBox
            placeholder=""
            value={purchaseOrderNumber}
            onChange={(e) => setPurchaseOrderNumber(e.target.value)}
            label="Enter Purchase Order Number"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <div style={{ flex: 1 }}>
              <UploadBox
                placeholder=""
                value={purchaseOrderFile}
                onChange={(e) => handleFileUpload(e)}
                label="Upload Purchase Order"
              />

              {purchaseOrderFileError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  Please upload .pdf files only
                </p>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        visible={rejectionModalVisible}
        title="Rejection Reasons"
        onCancel={() => {
          setRejectionModalVisible(false);
        }}
        onOk={() => {
          setRejectionModalVisible(false);
        }}
      >
        <h3>{orderDetails.reasonForRejectedByLab}</h3>
      </Modal>
    </div>
  );
};

export default OrderDetailsPage;
